import Hue from "./hue.vue";

export default Hue;
